import React, { useState } from 'react';
import { deleteMedia } from "../api/storages";

// component
import MediaList from '../components/Media/MediaList';
import TabPanel from '../components/TabPanel';
import Upload from '../components/Media/Upload';
import ConfirmDialog from '../components/ConfirmDialog';

// mui
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function Media() {

    // タブ
    const [value, setValue] = React.useState(0);
    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    function a11yProps(index: number) {
        return {
            id: `tab-${index}`,
            'aria-controls': `tabpanel-${index}`,
        };
    }

    // ストレージ使用状態
    const storageTotal = 3 * (1024 * 1024 * 1024); // 3GB
    const [storageUsed, setStorageUsed] = useState(0);

    // ファイル状態の再描画
    const [redrawByUpload, setRedrawByUpload] = useState<Date>();
    const [redrawByDelete, setRedrawByDelete] = useState<number>();

    /**
     * ファイルの削除
     */
    // 削除実行
    const fnDeleteMedia = async (fileId: string) => {
        const result = await deleteMedia(fileId);
        return result;
    }
    // 削除ハンドル
    const handleDeleteMedia = (mediaId: number) => {
        setTargetDeleteMedia(mediaId);
        setIsOpenConfirmDialog(true);
    }
    // 削除確認ダイアログ
    const [targetDeleteMedia, setTargetDeleteMedia] = useState(0);
    const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);
    const handleDeleteMediaAgree = () => {
        fnDeleteMedia(targetDeleteMedia.toString())
            .then((result) => {
                setRedrawByDelete(targetDeleteMedia);
            });
    }
    const handleDeleteMediaDisagree = () => {
        setTargetDeleteMedia(0);
    }

    return (
        <Box>
            {/* タブ */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChangeTab} aria-label="tabs" centered={true}>
                    <Tab label="ファイルアップロード" {...a11yProps(0)} />
                    <Tab label="アップロードファイル" {...a11yProps(1)} />
                </Tabs>
            </Box>

            {/* タブ - コンテンツ */}
            <TabPanel value={value} index={0}>
                {/* ファイルアップロード */}
                <Upload
                    redrawByDelete={redrawByDelete}
                    storageUsed={storageUsed}
                    storageTotal={storageTotal}
                    setRedrawByUpload={setRedrawByUpload}
                    handleDeleteMedia={handleDeleteMedia}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                {/* アップロードファイル */}
                <MediaList
                    redrawByUpload={redrawByUpload}
                    redrawByDelete={redrawByDelete}
                    storageUsed={storageUsed}
                    storageTotal={storageTotal}
                    setStorageUsed={setStorageUsed}
                    handleDeleteMedia={handleDeleteMedia}
                />
            </TabPanel>

            {/*削除確認ダイアログ*/}
            <ConfirmDialog
                agreeButtonDisplay={"削除する"}
                body={<>アップロードファイルは削除されます。<br />削除するとファイルが含まれているトピックやコメント内のファイルも表示されなくなります。</>}
                handleClickAgree={handleDeleteMediaAgree}
                handleClickDisagree={handleDeleteMediaDisagree}
                isOpen={isOpenConfirmDialog}
                setIsOpen={setIsOpenConfirmDialog}
                title={"ファイルを削除しますか？"}
            />
        </Box>
    );
}